var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVulnerabilitySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2352_24436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1688 11.1855H0V39.6582H10.1688V11.1855Z",
    fill: "#4AC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3407 5.08447H10.1719V39.6584H19.3237C19.3268 37.5159 19.6705 35.3886 20.3406 33.3537V5.08447H20.3407Z",
    fill: "#044D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3778 10.4668C39.9812 10.0702 39.3364 10.0702 38.9399 10.4668L33.8555 15.5512L35.2934 16.9891L39.6588 12.6236L43.0075 15.9722C43.404 16.3688 44.0488 16.3688 44.4454 15.9722L51.8614 8.55615V13.2195H53.8952V6.10131H53.8861C53.9013 5.55521 53.4713 5.09971 52.9252 5.08447C52.9099 5.08447 52.8947 5.08447 52.8784 5.08447H45.7602V7.11826H50.4236L43.7264 13.8154L40.3778 10.4668Z",
    fill: "#4AC3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2896 44.7427H1.01953V46.7765H17.2896V44.7427Z",
    fill: "#044D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2896 48.8101H1.01953V50.8438H17.2896V48.8101Z",
    fill: "#044D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2896 52.8774H1.01953V54.9112H17.2896V52.8774Z",
    fill: "#044D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5087 21.5223V0H20.3398V33.3537C22.0269 28.2175 25.6845 23.9618 30.5087 21.5223Z",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6782 19.3513C40.3426 19.3309 39.9969 19.3208 39.6614 19.3208C39.3259 19.3208 38.98 19.331 38.6445 19.3513V39.6583C38.6445 40.2197 39.1 40.6752 39.6614 40.6752H59.9684C59.9888 40.3396 59.9989 39.9938 59.9989 39.6583C59.9989 39.3228 59.9887 38.977 59.9684 38.6415C59.4437 28.2123 51.1063 19.8759 40.6782 19.3513Z",
    fill: "#044D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9347 40.6755H39.6613C39.1 40.6755 38.6445 40.22 38.6445 39.6586V19.3516C35.8104 19.495 33.0385 20.2342 30.5094 21.5226C20.4871 26.5805 16.4623 38.8045 21.5202 48.8268C26.5782 58.8491 38.8021 62.8739 48.8245 57.816C55.3507 54.5223 59.6064 47.9777 59.9684 40.6755H57.9347Z",
    fill: "#F7A010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2352_24436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulnerabilitySmall);
export default __webpack_public_path__ + "static/media/vulnerabilitySmall.f15126bb0df763e4ae4accb47bb1e654.svg";
export { ForwardRef as ReactComponent };